
import { defineComponent, ref, onBeforeMount } from 'vue'
import BlankCard from '@/components/blankCard/index.vue'
import History from '@/components/profile/history.vue'
import Download from '@/components/profile/download.vue'
import Member from '@/components/profile/member.vue'
import Revise from '@/components/profile/Revise.vue'
import { getUserInfo } from '@/api/profile'
import { UserInfo } from '@/api/type'
import router from '@/router'
import emitter from '@/utils/bus.js'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({
  components: {
    BlankCard,
    History,
    Download,
    Member,
    Revise,
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const activeName = ref<string>('first')
    const isEdit = ref<boolean>(false)
    const userInfoList = ref({} as UserInfo)
    const loading = ref<boolean>(false)

    store.commit('isMobile')
    const isMobile = store.state.isMobile

    const Edit = () => {
      if (isMobile) return
      isEdit.value = true
    }
    const close = () => {
      isEdit.value = false
    }
    const updateSucess = () => {
      isEdit.value = false
      asyncGetUserInfo()
    }
    const asyncGetUserInfo = async () => {
      try {
        loading.value = true
        const res = await getUserInfo()
        if (res.status) {
          userInfoList.value = res.data
          localStorage.setItem('avatarUrl', res.data.avatarUrl)
          emitter.emit('avatarUrl', res.data.avatarUrl)
        }
      } catch (err) {
        if (err.errorCode) {
          router.push('/login')
        }
      } finally {
        loading.value = false
      }
    }
    const uploadSuccess = () => {
      asyncGetUserInfo()
    }
    onBeforeMount(() => {
      asyncGetUserInfo()
      if (route.params.tabName === 'three') {
        activeName.value = route.params.tabName
      }
    })
    return {
      route,
      activeName,
      userInfoList,
      Edit,
      isEdit,
      close,
      updateSucess,
      uploadSuccess,
      isMobile,
    }
  },
})
